import { Col, Formatter, Row, useSelector } from 'gf-ui'
import { FaChevronRight, FaEdit, FaLevelDownAlt } from 'react-icons/fa'

const Categorie = ({ categorie, descField = "DESCRIZIONE", onSelCategoria }) => {
  const MAX_NUM_BOTTONI_RIGA = useSelector( state => Formatter.getFloat(state?.page?.data?.MAX_NUM_BOTTONI_RIGA) || 2)
  
  return <Row className='w-100 justify-content-center m-0'>
    {categorie && categorie.map((cat, index) =>
      <Col xs={12} md={MAX_NUM_BOTTONI_RIGA === 2 ? 6 : 4} className='d-flex justify-content-center'>
        <div key={index} style={{ width: '100%', maxWidth: MAX_NUM_BOTTONI_RIGA === 2 ? '450px' : '400px' }} className='animate__animated animate__flipInX'>
          <div className={`menu-questionario menu-item m-2 border rounded-pill px-4 bg-white d-flex flex-column align-items-start justify-content-center ${Formatter.isStringaVuota(cat.ID_MA_MODELLO) ? 'leveldown' : 'questionario'}`} onClick={() => onSelCategoria(cat)}>
            <div className="w-100 d-flex flex-row align-items-center justify-content-between">
              <span className='m-2 text-primary'><strong>{cat[descField]}</strong></span>
              <div style={{ width: '30px' }}>
                <>
                  {Formatter.isStringaVuota(cat.ID_MA_MODELLO) ?
                    <></>
                    :
                    <h4 className='m-0 icona'><FaEdit color="var(--bs-primary)" /></h4>
                  }
                  <h2 className='m-0 arrow'><FaChevronRight color="var(--bs-primary)" /></h2>
                  <h4 className='m-0 arrow-leveldown'><FaLevelDownAlt color="var(--bs-primary)" /></h4>
                </>
              </div>
            </div>
          </div>
        </div>
      </Col>
    )}
  </Row>
}

export default Categorie